// extracted by mini-css-extract-plugin
export default {"header":"LocationView_header__SyUH-","divider":"LocationView_divider__ZcIBQ","infiniteScroll":"LocationView_infiniteScroll__9uDKo","loader":"LocationView_loader__1XrGm"};